






























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import "@/styles/MCQ.scss";
import { GeneralService } from "../services/general-service";
import AuthService from "../services/auth-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";
import moment from "moment";
import EmojiRating from "../components/EmojiRating.vue"

@Component({
  components: {
    EmojiRating,
  },
})
export default class NoticeBoard extends Vue {
  private service = new GeneralService();
  private auth = new AuthService();
  private entities: GActivity[] = [];
  private level_id;
  private notifications: any = [];
  private notif:any = {};
  private filter = "";
  private isExams = "checked";
  private isAttendance = "checked";
  private isFees = "checked";
  private isGeneral = "checked";
  private isImage = true;
  private surveyTeachers: any = [];
  private surveyRating: any = [];
  private surveyHeading: any = "";
  private surveySelected: any = {};
  private surveyRemarks: string = "";
  private surveyExpired = false;
  private surveyNumber = 0;
  private surveyError = "";
  private todaySurvey = false;


  checkImage(src:string) {
    let type = src.substring(src.length-3, src.length);
    
    if (type.toLowerCase()=='jpg' || type.toLowerCase()=='png'){
      this.isImage = true;
    } else {
      this.isImage = false;
    }
  }

  downloadFile(link: string) {
    window.open(link, '_blank');
  }

  openExpired(survey){
    this.surveyExpired = false;
    this.todaySurvey = true;
    this.$bvModal.show("surveyNotice");
    this.surveyHeading = JSON.parse(survey.notificationObject).title;
  }

  openSurvey(survey) {
    let details = survey.notificationObject;
    this.surveyRating = [];
    this.surveyTeachers = details.data;
    this.surveyHeading = details.notification;
    this.surveySelected = survey;
    let today = moment().format("YYYY-MM-DD");
    this.surveyExpired = false;
    if (today !== details.expiry) this.surveyExpired = true;
    this.$bvModal.show("surveyNotice");
  }

  formattedDate(date) {
    // , h:mm:ss a
    return moment(date).format("DD-MM-YYYY");
  }

  goToType(notif, action) {
    let type = JSON.parse(notif.notificationObject).type;
    let image = JSON.parse(notif.notificationObject).image;
    if (!action) {  
      if (type == "Attendence") window.open("/attend", "_blank");
      else if (type == "Fee") window.open("/fees", "_blank");
      else if (type == "Examination") window.open("/examresult", "_blank");
      else if (image !== "") {
        this.notif = JSON.parse(notif.notificationObject);
        this.$bvModal.show("imageNotif");
      }
    } 
    
    else {
      if (type == "Survey") {
        this.openSurvey(notif)
      }else if (type=="Survey Form"){
        this.openExpired(notif)
      } 
      else {
        this.notif = JSON.parse(notif.notificationObject);
        this.$bvModal.show("imageNotif");
        this.checkImage(this.notif.image);
      }
    }
  }

  closeModal() {
    this.$bvModal.hide('imageNotif');
  }

  private urlify(text) {
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function(url) {
    return '<a target="_blank" href="' + url + '">' + url + '</a>';
  })
}

  getMessages(limit) {
    this.service
      .getNotifications(this.auth.session.userName.split("@")[0].toUpperCase(), limit)
      .then((response) => {
        
        this.notifications = response.data;
        console.log(this.notifications,'testings');
        this.notifications = this.notifications.filter(n => (JSON.parse(n.notificationObject).type !== 'Survey' && JSON.parse(n.notificationObject).type !== 'Survey Form'))
    
      
      });
  }

  mounted() {
    this.getMessages(40);
  }
}
